import { render, staticRenderFns } from "./DescripcionTareaModalComponent.vue?vue&type=template&id=0e849f8f&"
import script from "./DescripcionTareaModalComponent.vue?vue&type=script&lang=js&"
export * from "./DescripcionTareaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports